import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { ActionIcon } from "PFComponents/action_icon";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./engagement_progress.less";
import ProgressBar from "./progress_bar";

const EngagementProgress = ({ item }) => {
  const { customTypes } = useCustomTypes();

  const { t } = useTranslation("workflow", { keyPrefix: "parts.engagements" });
  const { formatDate } = useDateFormatter();

  const rolesCount = item.roles.length;
  const emptyEngagment = rolesCount === 0;

  const [collapsed, setCollapsed] = useState(rolesCount > 5);

  const engagementSharedAt = (
    item.audit_logs
      .filter((log) => log.action === "owner_created" && log.target_profile_id !== item.profile_id)
      .pop() || {}
  ).created_at;

  const brandsCustomType = customTypes.find(({ name }) => name === "brands");

  const duration = item.duration && (
    <span style={{ marginLeft: "auto", paddingLeft: 5 }}>
      {t("startingAtDate", { date: formatDate(item.duration.start_date) })}
    </span>
  );

  return (
    <div className={css.section}>
      <header>
        <ActionIcon
          fill="var(--palettePrimary0)"
          name={collapsed ? "caret-right" : "caret-down"}
          onClick={() => setCollapsed((prev) => !prev)}
          size="xs"
        />
        <div className={css.titleBox}>
          <div className={css.flex}>
            <div style={{ wordBreak: "break-word" }}>
              <ActivityPreviewLink
                activity={item}
                className={css.engagementLink}
                qaId={`WorkflowPageProgressActivityLink.${item.id}`}
              />
              {brandsCustomType && item.client && (
                <span className={css.client}> {`${brandsCustomType.display_as}: ${item.client}`} </span>
              )}
            </div>
            {!engagementSharedAt && duration}
          </div>
          {engagementSharedAt && (
            <div className={css.flex}>
              <span>{t("sharedAtDate", { date: formatDate(engagementSharedAt) })}</span>
              {duration}
            </div>
          )}
        </div>
      </header>
      {!collapsed && (
        <div className={css.content}>
          {emptyEngagment ? (
            <ProgressBar engagement={item} />
          ) : (
            item.roles.map((role) => <ProgressBar key={role.id} role={role} engagement={item} />)
          )}
        </div>
      )}
    </div>
  );
};

EngagementProgress.displayName = "engagement";

EngagementProgress.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    profile_id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    client: PropTypes.string,
    duration: PropTypes.object,
    roles: PropTypes.array.isRequired,
    audit_logs: PropTypes.arrayOf(
      PropTypes.shape({
        action: PropTypes.string.isRequired,
        created_at: PropTypes.string.isRequired,
        target_profile_id: PropTypes.number
      })
    )
  }).isRequired
};
export default EngagementProgress;
